module.exports = __webpack_public_path__ + "static/media/address_image.535a1d47.svg";